import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import InputFormat from "../../../../componentes/inputMask/inputMask";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import FilialService from "../../../../services/resource/filialService";
import ClienteService from "../../../../services/resource/clienteService";
import ItemAtivoEditor from "../shared/ItemAtivoEditor";
import NovaSolicitacaoLayout from "../shared/NovaSolicitacaoLayout";
import { useRascunhoFormulario } from "../../Rascunho/RascunhoContext";
import { listaDoRascunho, mesclarComPadrao } from "../../../../utils/solicitacoes/rascunhoStorage";
import { enviarAnexosStaged } from "../../../../utils/solicitacoes/anexosStaged";
import { enviarComentariosStaged } from "../../../../utils/solicitacoes/comentariosStaged";
import DateMasked from "../../../../componentes/inputMask/DateMasked";

const filialService = new FilialService();
const clienteService = new ClienteService();

const CODIGO_CLIENTE_REGEX = /^\d{4}-\d{4}$/;

const inicial = {
    filialId: null,
    codigoRota: "",
    supervisor: "",
    dataPrevistaRecolhimento: "",
    motivo: "",
    clienteCodigo: "",
    clienteRazaoSocial: "",
    clienteFantasia: "",
    clienteCidade: "",
    clienteEstado: "",
    clienteBairro: "",
    clienteEncontrado: null,
};

export default function NovaSolicitacaoRecolhimentoForm({ service, etapaInicialExigeAnexo, onCriada, encaminhar }) {
    const [form, setForm] = useState(inicial);
    const [itens, setItens] = useState([]);
    const [anexos, setAnexos] = useState([]);
    const [comentarios, setComentarios] = useState([]);

    // Rascunho (botão "Salvar rascunho" da página) — só campos, anexos ficam de fora.
    useRascunhoFormulario(
        () => ({ form, itens, comentarios }),
        dados => {
            setForm(mesclarComPadrao(inicial, dados.form));
            setItens(listaDoRascunho(dados.itens));
            setComentarios(listaDoRascunho(dados.comentarios));
        },
    );
    const [unidades, setUnidades] = useState([]);
    const [buscandoCliente, setBuscandoCliente] = useState(false);
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        filialService.listarAtivas().then(res => setUnidades(res.data)).catch(() => setUnidades([]));
    }, []);

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    function aoMudarCodigoCliente(valor) {
        const novoValor = valor || "";
        if (!CODIGO_CLIENTE_REGEX.test(novoValor)) {
            setForm(prev => ({ ...prev, clienteCodigo: novoValor, clienteEncontrado: null }));
            return;
        }
        setBuscandoCliente(true);
        clienteService.buscarPorCodigo(novoValor)
            .then(res => {
                const c = res.data;
                if (c.encontrado) {
                    setForm(prev => ({
                        ...prev, clienteCodigo: novoValor, clienteEncontrado: true,
                        clienteRazaoSocial: c.razaoSocial || "", clienteFantasia: c.fantasia || "",
                        clienteCidade: c.cidade || "", clienteEstado: c.estado || "", clienteBairro: c.bairro || "",
                    }));
                } else {
                    setForm(prev => ({
                        ...prev, clienteCodigo: novoValor, clienteEncontrado: false,
                        clienteRazaoSocial: "", clienteFantasia: "", clienteCidade: "", clienteEstado: "", clienteBairro: "",
                    }));
                    toast.info("Cliente não encontrado. Preencha os dados manualmente.");
                }
            })
            .catch(() => toast.error("Erro ao buscar cliente."))
            .finally(() => setBuscandoCliente(false));
    }

    const camposClienteDesabilitados = form.clienteEncontrado === true;

    function validar() {
        if (!form.filialId || !form.dataPrevistaRecolhimento) {
            toast.error("Preencha todos os campos obrigatórios.");
            return false;
        }
        if (!CODIGO_CLIENTE_REGEX.test(form.clienteCodigo)) {
            toast.error("Informe o código do cliente no formato 9999-9999.");
            return false;
        }
        if (!form.clienteRazaoSocial.trim() || !form.clienteFantasia.trim() || !form.clienteCidade.trim()
            || !form.clienteEstado.trim() || !form.clienteBairro.trim()) {
            toast.error("Preencha os dados do cliente.");
            return false;
        }
        if (itens.length === 0) {
            toast.error("Adicione ao menos um produto.");
            return false;
        }
        if (etapaInicialExigeAnexo && anexos.length === 0) {
            toast.error("É necessário anexar pelo menos um documento para concluir esta etapa.");
            return false;
        }
        return true;
    }

    async function enviar() {
        if (!validar()) return;

        let usuarioEscolhidoId;
        try {
            usuarioEscolhidoId = await encaminhar("ETAPA_2_ANALISE");
        } catch {
            return;
        }

        setEnviando(true);
        service.criarSolicitacao({
            ...form,
            usuarioEscolhidoId,
            itens: itens.map(i => ({ ...i, quantidade: Number(i.quantidade) })),
        })
            .then(async res => {
                const [{ falha: falhaAnexos }, { falha: falhaComentarios }] = await Promise.all([
                    enviarAnexosStaged(res.data.id, anexos),
                    enviarComentariosStaged(res.data.id, comentarios),
                ]);
                if (falhaAnexos.length > 0 || falhaComentarios.length > 0) {
                    const partes = [];
                    if (falhaAnexos.length > 0) partes.push(`${falhaAnexos.length} anexo(s) (${falhaAnexos.map(f => `${f.arquivo.name}: ${f.erro}`).join(", ")})`);
                    if (falhaComentarios.length > 0) partes.push(`${falhaComentarios.length} comentário(s)`);
                    toast.error(`Solicitação criada, mas houve falha ao enviar: ${partes.join(" e ")}.`);
                }
                onCriada(res.data);
            })
            .catch(error => console.error("Erro ao criar solicitação de recolhimento", error))
            .finally(() => setEnviando(false));
    }

    return (
        <NovaSolicitacaoLayout
            anexos={anexos}
            onAnexosChange={setAnexos}
            comentarios={comentarios}
            onComentariosChange={setComentarios}
            etapaInicialExigeAnexo={etapaInicialExigeAnexo}
        >
            <h3 className="text-sm font-semibold text-foreground">Informações Gerais</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <CustomDropdown label="Filial" required value={form.filialId} onChange={e => set("filialId", e.value)} options={unidades} optionValue="id" optionLabel="nome" placeholder="Selecione" filter />

                <Input label="Código da Rota" value={form.codigoRota} onChange={e => set("codigoRota", e.target.value)} />
                <Input label="Supervisor" value={form.supervisor} onChange={e => set("supervisor", e.target.value)} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <DateMasked type="date" label="Data prevista para recolhimento" required value={form.dataPrevistaRecolhimento} onChange={e => set("dataPrevistaRecolhimento", e)} />
                <div className="sm:col-span-2">
                    <Input label="Motivo" value={form.motivo} onChange={e => set("motivo", e.target.value)} />
                </div>
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Cliente</h3>

            <div className="grid grid-cols-1 sm:grid-cols-5 gap-4">
                <InputFormat
                    label="Código do Cliente"
                    required
                    mask="9999-9999"
                    value={form.clienteCodigo}
                    onChange={aoMudarCodigoCliente}
                    placeholder="0000-0000"
                />
                <div className="col-span-2">
                    <Input label="Razão Social" required disabled={camposClienteDesabilitados} value={form.clienteRazaoSocial} onChange={e => set("clienteRazaoSocial", e.target.value)} />
                </div>
                <div className="col-span-2">
                    <Input label="Nome Fantasia" required disabled={camposClienteDesabilitados} value={form.clienteFantasia} onChange={e => set("clienteFantasia", e.target.value)} />
                </div>
            </div>

            {buscandoCliente && <p className="text-xs text-muted-foreground -mt-2">Buscando cliente...</p>}
            {form.clienteEncontrado === false && <p className="text-xs text-amber-600 -mt-2">Cliente não encontrado — preencha os dados manualmente.</p>}
         
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Input label="Cidade" required disabled={camposClienteDesabilitados} value={form.clienteCidade} onChange={e => set("clienteCidade", e.target.value)} />
                <Input label="Estado" required disabled={camposClienteDesabilitados} value={form.clienteEstado} onChange={e => set("clienteEstado", e.target.value)} />
                <Input label="Bairro" required disabled={camposClienteDesabilitados} value={form.clienteBairro} onChange={e => set("clienteBairro", e.target.value)} />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Produtos</h3>
            <ItemAtivoEditor itens={itens} onChange={setItens} />

            <div className="flex justify-end">
                <Button variant="blue" label="Solicitar recolhimento" iconLeft="fa fa-paper-plane" loading={enviando} onClick={enviar} />
            </div>
        </NovaSolicitacaoLayout>
    );
}
